export { default as AngellistIcon } from "./Angellist";
export { default as ApplePayIcon } from "./ApplePay";
export { default as FacebookIcon } from "./Facebook";
export { default as GitHubIcon } from "./GitHub";
export { default as GoogleIcon } from "./Google";
export { default as InstagramIcon } from "./Instagram";
export { default as LinkedinIcon } from "./Linkedin";
export { default as MediumIcon } from "./Medium";
export { default as MessengerIcon } from "./Messenger";
export { default as TelegramIcon } from "./Telegram";
export { default as TwitterIcon } from "./Twitter";
export { default as WhatAppIcon } from "./WhatApp";
export { default as YoutubeIcon } from "./Youtube";
